import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@upmc/ims.component-library';
import { useCallback, useEffect, useState } from 'react';
import { DataTable } from '../../components/UI/MDC/DataTable/DataTable';
import { Subtitle1 } from '../../components/UI/MDC/Typography/Typography';
import { HEADERS } from './_constants';
import classes from './PendingApprovals.module.scss';
import { Box } from '@mui/system';

/**
 * React component for listing results of a bulk approval action.
 * @param {object} props Props for opening and closing the modal.
 * @returns React component.
 */
const ResultsModal = ({
	resultsModalOpen,
	setResultsModalOpen,
	resultsRows,
	setResultsRows,
}) => {
	const [successCount, setSuccessCount] = useState(0);

	// On close also clear results rows to avoid popup appearing again
	const closeDialog = useCallback(() => {
		setResultsRows([]);
		setResultsModalOpen(false);
	}, [setResultsModalOpen, setResultsRows]);

	// On change reveal dialogue and get success count
	useEffect(() => {
		if (resultsRows.length > 0) {
			setResultsModalOpen(true);
			setSuccessCount(
				resultsRows.filter(result => result.success).length
			);
		}
	}, [resultsRows, setResultsModalOpen]);

	// Return React component
	return (
		<Dialog
			open={resultsModalOpen}
			onClose={() => closeDialog()}
			className={classes.dialog__container}
		>
			<DialogTitle>Results</DialogTitle>

			<DialogContent className={classes.dialog__content}>
				{successCount === 0 ? (
					<Alert severity='error' sx={{ width: '100%' }}>
						Complete failure. Error processing{' '}
						{resultsRows.length > 1 ? 'all requests' : 'request'}.
					</Alert>
				) : successCount < resultsRows.length ? (
					<Alert severity='warning' sx={{ width: '100%' }}>
						Partial success. Successfully processed {successCount}/$
						{resultsRows.length} requests.
					</Alert>
				) : null}

				<Subtitle1>
					Your{' '}
					{resultsRows.length > 1 ? 'requests have' : 'request has'}{' '}
					been processed.
				</Subtitle1>

				<Box sx={{ width: '100%' }}>
					<DataTable
						headers={[
							{
								Value: HEADERS.HEADER_TRACKING_NUMBER,
								props: {
									alignMiddle: true,
								},
							},
							{
								Value: 'Message',
								props: {
									alignMiddle: true,
								},
							},
						]}
						rows={resultsRows}
					/>
				</Box>
			</DialogContent>

			<DialogActions>
				<Button variant='text' onClick={() => closeDialog()}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export { ResultsModal };
